
export const AppConfig = {
    checkInvitePermission : false,
}
